import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NewDisciplineForm from 'components/Admin/Discipline/NewDisciplineForm';
import actions from 'actions';
import constants from 'constants';
import validator from 'services/validator';
import inputFormatter from 'services/userInputFormatter';

const {
  CREATE_DISCIPLINE_SAGA
} = constants;

const {
  createDisciplineSaga,
  cleanErrors
} = actions;

class NewDiscipline extends Component {
  static propTypes = {
    createDiscipline: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj
  };

  constructor(props) {
    super(props);
    this.state = {
      discipline: {
        title: '',
        discipline_type:[]
      }
    }
  }

  componentWillMount() {
    this.props.cleanErrors();
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const disciplineData = { ...this.state.discipline,
      ...{
        [e.target.name]: input
      }
    }

    this.setState({ discipline: disciplineData });
  }

  onRoleDisciplineChange = (discipline_type) => {
    this.onFieldChange({
      target: {
        name: 'discipline_type',
        value: (discipline_type || []).map(discipline => discipline.value)
      }
    });
  }

  onSubmit = () => {
    this.props.createDiscipline(this.state.discipline)
  }

  render() {
    const {
      errors,
      errorsFrontend
    } = this.props;
    return (
      <main className="site--width clearfix-c">
        <NewDisciplineForm
          onFieldChange={this.onFieldChange}
          discipline={this.state.discipline}
          onSubmit={this.onSubmit}
          onRoleDisciplineChange={this.onRoleDisciplineChange}
          errors={validator.formatErrors(errors, errorsFrontend)}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[CREATE_DISCIPLINE_SAGA],
    errorsFrontend: state.errors[`${CREATE_DISCIPLINE_SAGA}_FRONTEND`]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createDiscipline: (discipline) => dispatch(createDisciplineSaga(discipline)),
    cleanErrors: () => dispatch(cleanErrors(CREATE_DISCIPLINE_SAGA)),
    dispatch: dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewDiscipline);



// WEBPACK FOOTER //
// ./src/containers/Admin/Discipline/NewDiscipline.jsx